interface SchemaWithRegistry {
  registry: {
    organization: {
      id: string;
    };
  };
}

export function filterSchemasByRegistryOrganization<T extends SchemaWithRegistry>(
  schemas: Array<T>,
  organizationId: string
): Array<T> {
  return schemas.filter((schema) => schema.registry.organization.id === organizationId);
}

interface SchemaWithOrganizationJson {
  organizationJson: {
    id: string;
  };
}

export function filterSchemasByOrganizationJson<T extends SchemaWithOrganizationJson>(
  schemas: Array<T>,
  organizationId: string
): Array<T> {
  return schemas.filter((schema) => schema.organizationJson.id === organizationId);
}
